 
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
type ShimmerType = 'tableShimmer' | 'profileShimmer' | 'cardsShimmer' |'profileCardShimmer'|'formsShimmer';
@Component({
  selector: 'app-shimmer-loader',
  standalone: true,
  imports: [CommonModule, NgxSkeletonLoaderModule],
  templateUrl: './shimmer-loader.component.html',
  styleUrls: ['./shimmer-loader.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ShimmerLoaderComponent implements OnChanges {
  @Input() type: ShimmerType = 'tableShimmer';
  @Input() columnsCount = 3;
  @Input() rowsCount = 5;
  @Input() pagination = true;
  @Input() image = true;
  @Input() showThirdLine = false;
  @Input() cardsCount = 6;
  @Input() cardLineCount = 3;
 
// image = true;          // when true -> circle shows
// showThirdLine = true;  // show/hide third line
 
 
  rows: number[] = []; //for table how many rows and for cards showing the number of cards.
  cols: number[] = [];//for table how many columns and for cards showing the number of lines inside the card.
  cards: number[] = [];//how many cards
  cardLines: number[] = [];//how many lines inside the card
 
  ngOnChanges(): void {
 
    if (this.type === 'profileShimmer') {
      this.rows = Array.from({ length: this.rowsCount }, (_, i) => i);
      this.cols = [];
      this.cards = [];
      return;
    }
 
    if (this.type === 'cardsShimmer') {
      this.cards = Array.from({ length: this.cardsCount }, (_, i) => i);
      this.cardLines = Array.from({ length: this.cardLineCount }, (_, i) => i);
      this.rows = [];
      this.cols = [];
      return;
    }
 
if (this.type === 'profileCardShimmer') {
  this.cards = Array.from({ length: this.cardsCount }, (_, i) => i);
  this.cardLines = [];
  this.rows = [];
  this.cols = [];
  return;
}
if (this.type === 'formsShimmer') {
  console.log('manager');
  this.cards = [];
  this.cardLines = [];
  this.rows = [];
  this.cols = [];
  return;
}
 
 
    if (this.pagination) {
      this.buildGrid(6, 6);
      this.cards = [];
      return;
    }
 
    this.buildGrid(this.rowsCount, this.columnsCount);
    this.cards = [];
    this.cardLines = [];
  }
 
  private buildGrid(r: number, c: number) {
    this.rows = Array.from({ length: r }, (_, i) => i);
    this.cols = Array.from({ length: c }, (_, i) => i);
  }
 
  trackByIndex = (i: number) => i;
}
 
 
// always you have to send pagination wether true or false if you dont sent then it would automatically take 6*6 pagination
// You can pass three things 'tableShimmer' | 'profileShimmer' | 'cardsShimmer' otherwise by default pagination
// Profile shimmer is showing one circle and two lines.
// if you want to use profileShimmer then   <app-shimmer-loader [pagination]="false"  type="profileShimmer"> </app-shimmer-loader> use like this
// for table you can also able to send row and col otherwise it will take 5 row 3 col
// cards we are shoiwng cards and some line inside it and you can send card count and line count.
 